module.exports = __webpack_public_path__ + "img/202408_01.6735db47.jpg";